import { render, staticRenderFns } from "./info-affirm.vue?vue&type=template&id=a654dfa8&scoped=true&"
import script from "./info-affirm.vue?vue&type=script&lang=js&"
export * from "./info-affirm.vue?vue&type=script&lang=js&"
import style0 from "./info-affirm.vue?vue&type=style&index=0&id=a654dfa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a654dfa8",
  null
  
)

export default component.exports